import Vue from "vue";
import App from "./App.vue";
import router from "./routes/index";
import * as firebase from "firebase";
import store from "./store";
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import VueFire from 'vuefire'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
//Vue.use(VueFire)

const configOptions = {
  apiKey: "AIzaSyAAtRgvpyH43QzUq0VDzBs25-21RIawizI",
  authDomain: "saddle-expert.firebaseapp.com",
  databaseURL: "https://saddle-expert.firebaseio.com",
  projectId: "saddle-expert",
  storageBucket: "saddle-expert.appspot.com",
  messagingSenderId: "742808887913",
  appId: "1:742808887913:web:f1ed311afa3926fa8978f8"
};

firebase.initializeApp(configOptions);

firebase.auth().onAuthStateChanged(user => {
  store.dispatch("fetchUser", user);

  // récup token
  firebase.auth().currentUser.getIdToken()
  .then(res => {
    const db = firebase.database(); 
    //firebase.database.enableLogging(true);

    let token = res;
    //console.log('token: ', token);
    localStorage.setItem('tokenId', token);
  });
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
